import { oc } from "@orpc/contract";
import { contract as accounting } from "./accounting/v1alpha1";
import { contract as accounts } from "./accounts/v1alpha1";
import { contract as activity } from "./activity/v1alpha1";
import { contract as agents } from "./agents/v1alpha1";
import { contract as aiAlibaba } from "./ai/alibaba/v1alpha1";
import { contract as aiAnthropic } from "./ai/anthropic/v1alpha1";
import { contract as aiCalls } from "./ai/calls/v1alpha1";
import { contract as aiModels } from "./ai/models/v1alpha1";
import { contract as aiOpenai } from "./ai/openai/v1alpha1";
import { contract as aiOpenrouter } from "./ai/openrouter/v1alpha1";
import { contract as aiVertex } from "./ai/vertex/v1alpha1";
import { contract as assets } from "./assets/v1alpha1";
import { contract as basemaps } from "./basemaps/v1alpha1";
import { contract as catalog } from "./catalog/v1alpha1";
import { contract as comments } from "./comments/v1alpha1";
import { productApiErrors } from "./common";
import { contract as evals } from "./evals/v1alpha1";
import { contract as friends } from "./friends/v1alpha1";
import { contract as games } from "./games/v1alpha1";
import { contract as internalServices } from "./internal/v1alpha1";
import { contract as moderation } from "./moderation/v1alpha1";
import { contract as payments } from "./payments/v1alpha1";
import { contract as presets } from "./presets/v1alpha1";
import { contract as profiles } from "./profiles/v1alpha1";
import { contract as risk } from "./risk/v1alpha1";
import { contract as speech } from "./speech/v1alpha1";
import { contract as staff } from "./staff/v1alpha1";
import { contract as traces } from "./traces/v1alpha1";
import { contract as waitlist } from "./waitlist/v1alpha1";

/**
 * Every route the API's oRPC handler serves. The Product API's errors are declared once, here, on
 * every `/api` procedure.
 */
export const contract = {
  ...oc.errors(productApiErrors).router({
    accounting,
    accounts,
    activity,
    agents,
    ai: { calls: aiCalls, models: aiModels },
    assets,
    basemaps,
    catalog,
    comments,
    evals,
    friends,
    games,
    moderation,
    payments,
    presets,
    profiles,
    risk,
    speech,
    staff,
    traces,
    waitlist,
  }),
  internal: {
    catalog: internalServices.catalog,
    games: internalServices.games,
    drafts: internalServices.drafts,
    basemaps: internalServices.basemaps,
    moderation: internalServices.moderation,
  },
} as const;

/**
 * The vendor transports. Hono routes serve them, because SDKs expect each vendor's own bytes, so
 * they stay out of `contract`.
 */
export const aiPassthroughContracts = {
  aiAlibaba,
  aiAnthropic,
  aiOpenai,
  aiOpenrouter,
  aiVertex,
} as const;
